{
  "version": 1,
  "asset_id": "5859eb60-4d80-4fa5-bddc-d69eb8c80876",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/5859eb60-4d80-4fa5-bddc-d69eb8c80876/svc-ppc-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/5859eb60-4d80-4fa5-bddc-d69eb8c80876/svc-ppc-640.avif",
  "original_filename": "svc-ppc-640.avif",
  "size": 4742,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:54Z"
}
